/// <reference path="guidservice.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../oauthtoken.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../ilocalstorage.d.ts" />

module App.Common.Services {
	'use strict';

	export class GlobalSettingsService {

		//Passed through from server-side config
		private _appConfig : any = window['__appConfig'];

		public applicationName: string = this._appConfig.applicationName;
		public applicationNameShort: string = this._appConfig.applicationNameShort;
		public verboseLogging: boolean = this._appConfig.verboseLogging;
		public showVerboseDebugMessages: boolean = this._appConfig.showVerboseDebugMessages;
		public showDebugInfo: boolean = this._appConfig.showDebugInfo;
		public googleAnalyticsTrackingId: string = this._appConfig.googleAnalyticsTrackingId;
		public useWindowsAuthentication: boolean = this._appConfig.useWindowsAuthentication;
		public databaseName: string = this._appConfig.databaseName;
		public cookieDomain: string = this._appConfig.cookieDomain;
		public hiloSupportStart: string = this._appConfig.hiLOSupportStart;
		public allowedFileUploadExtensions: string[] = this._appConfig.allowedFileUploadExtensions;
		public maxFileUploadSize: number = this._appConfig.maxFileUploadSize;
		public emails = {
			regConsentsEmail: this._appConfig.hiLORegConsentsEmail,
			capitaMortgageEmail: this._appConfig.hiLOCapitaMortgageEmail,
			contactUs: this._appConfig.contactUsEmail,
			destinationEmail: this._appConfig.hiLODestinationEmail,
			postSalesAgentContactEmail: this._appConfig.hiLOPostSalesAgentContactEmail,
			chargesTeamEmail: this._appConfig.hiLOChargesTeamEmail,
			corporateContactEmail: this._appConfig.hiLOCorporateContactEmail,
            digitalServicesFeedbackEmail: this._appConfig.hiLODigitalServicesFeedbackEmail,
            calEnquiresEmail: this._appConfig.hiLOCalEnquiresEmail,
            rnTeamEmail: this._appConfig.hiLORnTeamEmail
		};
		
		//location of the unauthorized page
		public unauthorized = '/Error/Unauthorized';

		public authenticationBaseUrl: string;
		public authenticationEndpoints: {
			base: string,
			negotiate: string,
			token: string,
			requestPasswordReset: string,
            resetPassword: string,
            changePassword: string;
		};

		public broadcastEvents = {
			authenticationComplete: 'authenticationComplete'
		};

		public oAuthClientId = 'hilo';

		public cookieNames = {
			authToken: 'authToken',
			windowsAuthTokenValid: 'windowsAuthTokenValid'
		};
		// Todo: SS for WW - push  these down to the StringFormats.cs as they  already exist in there
		public shortDateFormat = 'dd/MM/yyyy';
		public shortDateTimeFormat = 'dd/MM/yyyy \'at\' HH:mm';
		public preciseDateTimeFormat = 'dd/MM/yyyy HH:mm:ss.sss';
		public dropdownUnselectedValue = '-- Select --';

		public datepickerOptions = {
			showWeeks: false,
			startingDay: 1,
			clearText: 'Clear',
			closeOnDateSelection: true,
			closeText: 'Done',
			currentText: 'Today',
			showButtonBar: true,
			maxDate: Date.now()
		};

		public mainFormName = 'mainForm';

		public emailRegexp = /(^.+\@.+\..+$)|(^\s*$)/i;

        public postcodeRegexp = /^[a-z]{1,2}[0-9][a-z0-9]?\s?[0-9][a-z]{2}$/i;

        public numRegexp = new RegExp('^[0-9]*$');

		public inputMasks = {
			schemeNo: {mask: '999999', description: 'a valid 6 digit scheme number'},

			numericMax: (maxLength: number) => {
				return {
					mask: _.repeat('9?', maxLength),
					description: `a numeric value of up to ${maxLength} characters`
				};
			},

			alphabeticMax: (maxLength: number) => {
				return {
					mask: _.repeat('9?', maxLength),
					description: `text up to ${maxLength} characters in length`
				};
			}
		};

		public isLocalhost = this.$location.host().toLowerCase() === 'localhost';

		public baseUrl: string;
		public baseUrlInternal: string;
		public baseUrlExternal: string;

		public static $inject = ['$location'];
		constructor(private $location: angular.ILocationService) {

			var protocol = `${this.$location.protocol()}://`;
			var currentDomain = this.$location.host().toLowerCase();
			var port = (this.$location.port() !== 80 && this.$location.port() !== 443)
				? `:${this.$location.port()}`
				: '';
			var internalSubDomain = '', externalSubDomain = '', topDomain = currentDomain;

			if (/\S+\.\S+/.test(currentDomain)) {
				var subDomain = currentDomain.substr(0, currentDomain.indexOf('.'));
				topDomain = currentDomain.substr(subDomain.length);
				internalSubDomain = subDomain.replace('-ext', '');
				externalSubDomain = `${internalSubDomain}-ext`;
			}

			this.baseUrl = `${protocol}${currentDomain}${port}`;
			this.baseUrlInternal = `${protocol}${internalSubDomain}${topDomain}${port}`;
			this.baseUrlExternal = `${protocol}${externalSubDomain}${topDomain}${port}`;
			this.authenticationBaseUrl = this.baseUrl;

			this.authenticationEndpoints = {
				base: this.authenticationBaseUrl,
				negotiate: `${this.authenticationBaseUrl}/api/Authentication/Negotiate`,
				token: `${this.authenticationBaseUrl}/api/Authentication/Token`,
				requestPasswordReset: `${this.authenticationBaseUrl}/api/Authentication/RequestPasswordReset`,
				resetPassword: `${this.authenticationBaseUrl}/api/Authentication/ResetPassword`,
				changePassword: `${this.authenticationBaseUrl}/api/Authentication/ChangePassword`
			};
		}
	}

	angular
		.module('app.common.services')
		.service('app.common.services.globalSettingsService', GlobalSettingsService);
}